import { render, staticRenderFns } from "./PlanYearReport.vue?vue&type=template&id=21f5223a&scoped=true"
import script from "./PlanYearReport.vue?vue&type=script&lang=js"
export * from "./PlanYearReport.vue?vue&type=script&lang=js"
import style0 from "./PlanYearReport.vue?vue&type=style&index=0&id=21f5223a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5223a",
  null
  
)

export default component.exports